import ConfirmationModal from "library/Molecules/Modal/ConfirmationModal";
import { PropTypes } from "prop-types";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

const ConfirmOverwriteOrderModal = ({ onConfirm, onClose }) => {
  const { t } = useTranslation();

  const handleConfirm = useCallback(() => {
    onConfirm();
    onClose();
  }, [onClose, onConfirm]);

  return (
    <ConfirmationModal
      id="confirm-overwrite-modal"
      title={t("newOrder.modals.overwriteOrderModal.title")}
      description={t("newOrder.modals.overwriteOrderModal.description")}
      onConfirm={handleConfirm}
      onDecline={onClose}
      declineBtnText={t("common.buttons.cancelBtn")}
      confirmBtnText={t("common.buttons.confirmBtn")}
    />
  );
};

ConfirmOverwriteOrderModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ConfirmOverwriteOrderModal;
